import { render, staticRenderFns } from "./Interactive.vue?vue&type=template&id=edda548a&scoped=true&"
import script from "./Interactive.vue?vue&type=script&lang=js&"
export * from "./Interactive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edda548a",
  null
  
)

export default component.exports